var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLoading)?_c('vs-card',[_c('FormImportLeads',{attrs:{"idUsuarioUpload":_vm.idUsuarioUpload},on:{"refreshList":_vm.refreshList}}),_c('ListImportacoes',{key:_vm.listImportacoesKey,attrs:{"idUsuarioUpload":_vm.idUsuarioUpload,"listImportacoes":_vm.listImportacoes}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }